import $ from 'jquery'
import { Fancybox } from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox.css'

$(document).ready(dhsv_vc_willkommen())

function dhsv_vc_willkommen() {
  Fancybox.bind('a.fancybox', {})
}
